import { createContext, FC, PropsWithChildren, useMemo } from 'react';
import { FormSelectOption } from '../components/form/FormSelect';
import { Customer } from '../customers/dto/Customer';
import { useCustomers } from '../hooks/useCustomers';

interface TransactionsContextValue {
  customersSelectOptions: FormSelectOption<Customer | null>[] | null;
}

export const TransactionsContext = createContext({} as TransactionsContextValue);

function useTransactionsContextValue(): TransactionsContextValue {
  const { data: customers } = useCustomers();
  const customersSelectOptions = useMemo<FormSelectOption<Customer | null>[] | null>(() => {
    if (customers) {
      const options: FormSelectOption<Customer | null>[] = [
        {
          label: '',
          value: null,
        },
      ];

      customers.forEach((customer) =>
        options.push({
          label: customer.name,
          value: customer,
        }),
      );

      return options;
    }

    return null;
  }, [customers]);

  return { customersSelectOptions };
}

export const TransactionsContextProvider: FC<PropsWithChildren> = ({ children }) => (
  <TransactionsContext.Provider value={useTransactionsContextValue()}>{children}</TransactionsContext.Provider>
);
